export default __webpack_public_path__ + "static/media/canvas-red.c5da859f.webp";